export { default } from './page/_index.tsx';
import { json, LinksFunction } from '@remix-run/node';
import type { MetaFunction } from '@remix-run/node';
import { externalAction, externalLoader } from '~/utils/externalLoader.server';
export const action = externalAction;
export const loader = externalLoader;
//! remove later
// export const action = async () => {
// 	return json({ message: 'Not Found' }, { status: 404 });
// };
// export const loader = async () => {
// 	return json({ message: 'Not Found' }, { status: 404 });
// };
//! remove later
import { useTranslation } from 'react-i18next';

export const meta: MetaFunction = ({ data }: any) => {
	let { t } = useTranslation(['project_yobo-website']);

	let lang = data.userLanguage === 'de' ? '' : data.userLanguage + '/';

	return [
		{
			title: t('routeTitle'),
		},
		{
			name: 'title',
			content: t('routeTitle'),
		},
		{
			property: 'og:title',
			content: t('routeTitle'),
		},
		{
			name: 'twitter:title',
			content: t('routeTitle'),
		},
		{
			name: 'description',
			content: t('routeOther'),
		},
		{
			property: 'og:description',
			content: t('routeOther'),
		},
		{
			name: 'twitter:description',
			content: t('routeOther'),
		},
		{
			property: 'og:url',
			content: 'https://northrock.software/' + lang + 'references/yobo-website/',
		},
		{
			name: 'twitter:url',
			content: 'https://northrock.software/' + lang + 'references/yobo-website/',
		},
	];
};

import yoboBuchung from '~/content/images/references/yobo-website/website-yobo-buchen.webp';
import clientYOBO from '~/content/svg/clients/yobo_Logo_schwarz.webp';
import yoboWebsiteHome from '~/content/images/references/yobo-website/yobo-website-home.webp';
import yoboHelena from '~/content/images/references/yobo-website/yobo-helena-eifler.webp';
import yoboTeam from '~/content/images/references/yobo-website/website-yobo-team.webp';
import react2 from '~/content/images/references/technologies/react.webp';
import figma from '~/content/images/references/technologies/figma_black.webp';
import magicline from '~/content/images/references/technologies/magicline.webp';
import payload from '~/content/images/references/technologies/payload_dark.svg';
import tailwind from '~/content/images/references/technologies/tailwind2.webp';
import lotti from '~/content/images/references/technologies/lotti.png';

export const links: LinksFunction = () => {
	return [
		{
			rel: 'preload',
			href: yoboBuchung,
			as: 'image',
		},
		{
			rel: 'preload',
			href: clientYOBO,
			as: 'image',
		},
		{
			rel: 'preload',
			href: yoboWebsiteHome,
			as: 'image',
		},
		{
			rel: 'preload',
			href: yoboHelena,
			as: 'image',
		},
		{
			rel: 'preload',
			href: yoboTeam,
			as: 'image',
		},
		{
			rel: 'preload',
			href: react2,
			as: 'image',
		},
		{
			rel: 'preload',
			href: figma,
			as: 'image',
		},
		{
			rel: 'preload',
			href: magicline,
			as: 'image',
		},
		{
			rel: 'preload',
			href: react2,
			as: 'image',
		},
		{
			rel: 'preload',
			href: payload,
			as: 'image',
		},
		{
			rel: 'preload',
			href: tailwind,
			as: 'image',
		},
		{
			rel: 'preload',
			href: lotti,
			as: 'image',
		},
	];
};
